import { FAQ_ITEMS } from '@/features/landing-page/lp-faq-section'
import { FaqStructuredData } from '@/components/seo/structured-data'
import { LpFaqAccordion } from '@/features/landing-page/v3/lp-faq-accordion'
import { LP_GRID } from '@/features/landing-page/v3/lp-grid'

/**
 * lp-v3 FAQ — same items as the live landing FAQ, in the redesign styling: a 40px two-line heading
 * ("Have questions?" in ink, "Find your answers." in the pixel font, orange) over the shared
 * lp-v3 accordion in its card variant. `!` beats the `.ds2` element typography that still wraps
 * the shell.
 */
export function LpFaqSectionV3() {
    return (
        <section className={`${LP_GRID.contentSection} py-[60px] md:py-[100px]`}>
            <FaqStructuredData items={FAQ_ITEMS} />
            <div className="mx-auto w-full max-w-[880px]">
                <h2 className="text-center text-[32px]! font-medium leading-[1.1]! tracking-[-0.01em]! text-[#131210] md:text-[40px]!">
                    <span className="block">Have questions?</span>
                    <span className="block font-[family-name:var(--font-landing-pixel)]! text-[#FF5500]!">
                        Find your answers.
                    </span>
                </h2>

                <LpFaqAccordion items={FAQ_ITEMS} variant="cards" className="mt-10 md:mt-14" />
            </div>
        </section>
    )
}
